module.exports = isWidget

function isWidget(w) {
    return w && w.type === "Widget"
}



//////////////////
// WEBPACK FOOTER
// ./~/virtual-hyperscript/~/vtree/is-widget.js
// module id = 70
// module chunks = 0